/**
 * Props for the SlidoView component.
 */
export interface SlidoViewProps {
  /**
   * The type of the Slido event.
   * @default 'event'
   */
  type?: 'event';
  /**
   * The ID of the Slido event.
   */
  slidoId: string;
}

/**
 * A component that renders a Slido event in an iframe.
 * @param props The props for the SlidoView component.
 * @returns A React component.
 * example url: https://app.sli.do/event/mt4UipBKY8pLxFhct2P7bc
 */
export function SlidoView({ type = 'event', slidoId }: SlidoViewProps) {
  return (
    <iframe
      height="100%"
      width="100%"
      style={{ minHeight: '560px' }}
      title={'Slido'}
      src={`https://app.sli.do/${type}/${slidoId}`}
    />
  );
}

export default SlidoView;
